import { BoxProperty } from 'models';

export const boxPropertyToString = ({
  top = 0,
  left = 0,
  right = 0,
  bottom = 0,
} = {} as Partial<BoxProperty>): string => `${top}px ${right}px ${bottom}px ${left}px`;
